import { action } from 'satcheljs';
import KeyStrokeCounterViewState from '../store/schema/KeyStrokeCounterViewState';

export default action(
    'updateKeyStrokeCounterViewStateAction',
    (viewState: KeyStrokeCounterViewState, keyStrokeCount: number) => {
        return { viewState: viewState, keyStrokeCount: keyStrokeCount };
    }
);
